import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import './HeaderBar.css';

export default class HeaderBar extends Component {
  goToSplash() {
    browserHistory.push('/');
  }

  render() {
    var { className, rightAction } = this.props;
    var rootClassName = className ? className + ' header-container' : 'header-container';
    return (
      <div className="header-bar">
        <div className={rootClassName}>
          <div className="header-left">
            <div className="mixfont--header"
              onClick={this.goToSplash}>
              MIXFONT
            </div>
          </div>
          {rightAction}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/HeaderBar.jsx